import { ID } from '@app/types';

let store = null;

export const injectStore = (_store) => (store = _store);

export default function isStarred(contactID: ID) {
  if (!store) {
    return false;
  }

  const starred = store.getState().data.starred;
  return starred.items.has(contactID);
}
